import searchPopulate from "./searchPopulate";

export const goTo = (pathname, exclude) => {
  location.href = searchPopulate(pathname, exclude);
};

export const postRedirect = (url, data) => {
  const form = document.createElement("form");
  document.body.appendChild(form);
  form.method = "POST";
  form.action = url;
  for (let name in data) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = data[name];
    form.appendChild(input);
  }
  form.submit();
};
